import PartnerDocumentCompleted from './partner-document-completed';

export default PartnerDocumentCompleted;